
  import { initSubpageI18n } from '/src/subpage-i18n.js';

  // Theme toggle
  const KEY = 'forro-seq-theme';
  const btn = document.getElementById('themeBtn');
  const saved = localStorage.getItem(KEY);
  if (saved === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
    btn.textContent = 'LIGHT';
  }
  btn.addEventListener('click', () => {
    const isLight = document.documentElement.getAttribute('data-theme') === 'light';
    document.documentElement.setAttribute('data-theme', isLight ? 'dark' : 'light');
    localStorage.setItem(KEY, isLight ? 'dark' : 'light');
    initSubpageI18n();
  });

  initSubpageI18n();
